import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'zwi-display',
    templateUrl: './display.component.html',
    styleUrls: ['./display.component.scss'],
    standalone: false
})
export class DisplayComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
